import _ from 'lodash'
import {
  categoryConfig,
  findCatgeory,
  gameConfigCategoryResourceType,
  isGlobalCategory,
  traverseCategory,
} from '@/store/creative/common/category'
import { generateGameConfigResource } from '@/store/creative/common/index'
import { isGameConfigWithoutRelate } from '@/views/creative/utils'

export const addMappingPathToGameConfig = ({ config, mappingPath }) => {
  if (_.isPlainObject(config)) {
    config.mw_mapping_path = mappingPath // 与 json_config.gameConfig 的映射路径，方便找到配置的原始值
  }
  _.each(config, (outer, key) => {
    if (
      key === 'items' &&
      outer &&
      (_.isPlainObject(outer) || _.isArray(outer))
    ) {
      _.each(outer, (inner, key2) => {
        addMappingPathToGameConfig({
          config: inner,
          mappingPath: `${mappingPath}[${key}][${key2}]`,
        })
      })
    }
  })
}

export const cookGameConfig = (gameConfig) => {
  _.each(gameConfig, (item, key) => {
    addMappingPathToGameConfig({
      config: item,
      mappingPath: `[gameConfig][${key}]`,
    })
  })
  return gameConfig
}

export const getGameConfigKeyListInCategory = (category) => {
  let keys = {}
  traverseCategory(
    {
      sub_category: category,
    },
    (cat) => {
      if (
        cat.resource_type === gameConfigCategoryResourceType &&
        !isGlobalCategory(cat.id)
      ) {
        keys = {
          ...keys,
          [cat.prefix]: {
            prefix: cat.prefix,
          },
        }
      }
    },
  )
  return _.cloneDeep(keys)
}

function reviewParams({ categoryList, hasInitGameConfigCategory, gameConfig }) {
  if (hasInitGameConfigCategory) {
    if (categoryList) return true
    throw new Error('传参错误')
  } else {
    if (gameConfig) return true
    throw new Error('传参错误')
  }
}

export const hasCustomGameConfigInGameConfigTab = ({
  categoryList,
  hasInitGameConfigCategory,
  gameConfig,
}) => {
  reviewParams({
    categoryList,
    hasInitGameConfigCategory,
    gameConfig,
  })
  // 已经初始化过玩法分类
  if (hasInitGameConfigCategory) {
    const gameConfigCategory = categoryList.filter(
      (item) => item.id === categoryConfig.gamePlay.id,
    )
    const gameConfigKeysInsideGameConfigTab =
      getGameConfigKeyListInCategory(gameConfigCategory)
    return !_.isEmpty(gameConfigKeysInsideGameConfigTab)
  }
  let flag = false
  _.each(gameConfig, (item) => {
    if (isGameConfigWithoutRelate(item)) flag = true
  })
  return flag
}

export const customGameConfigKeysInGameConfigTab = ({
  categoryList,
  hasInitGameConfigCategory,
  gameConfig,
}) => {
  reviewParams({
    categoryList,
    hasInitGameConfigCategory,
    gameConfig,
  })
  if (hasInitGameConfigCategory) {
    const gameConfigCategory = categoryList.filter(
      (item) => item.id === categoryConfig.gamePlay.id,
    )
    return Object.keys(getGameConfigKeyListInCategory(gameConfigCategory))
  }
  const keys = []
  _.each(gameConfig, (item, attr) => {
    if (isGameConfigWithoutRelate(item)) keys.push(attr)
  })
  return keys
}

export const customGameConfigKeysOutsideOfGameConfigTab = ({
  categoryList,
  hasInitGameConfigCategory,
  gameConfig,
}) => {
  reviewParams({
    categoryList,
    hasInitGameConfigCategory,
    gameConfig,
  })
  if (hasInitGameConfigCategory) {
    const cats = categoryList.filter(
      (item) => item.id !== categoryConfig.gamePlay.id,
    )
    return Object.keys(getGameConfigKeyListInCategory(cats))
  }
  const keys = []
  _.each(gameConfig, (item, attr) => {
    if (!isGameConfigWithoutRelate(item)) keys.push(attr)
  })
  return keys
}

/**
 * 根据 category 重新处理玩法的存储
 */
export const cookGameConfigResourceByCategory = ({
  gameConfigResource,
  categoryList,
  hasInitGameConfigCategory,
  gameConfig,
}) => {
  const gameConfigKeysInsideGameConfigTab = customGameConfigKeysInGameConfigTab(
    {
      categoryList,
      hasInitGameConfigCategory,
      gameConfig,
    },
  )

  const gameConfigKeysOutsideGameConfigTab =
    customGameConfigKeysOutsideOfGameConfigTab({
      hasInitGameConfigCategory,
      categoryList,
      gameConfig,
    })

  const currentGameDifficulty = (
    gameConfigResource.gameDifficultyList || []
  ).find((item) => item.is_default)

  if (!_.isEmpty(gameConfigKeysOutsideGameConfigTab)) {
    _.each(gameConfigKeysOutsideGameConfigTab, (prefix) => {
      // 没有从 gameConfigResource 找到对应的（说明是从玩法移动到了元素或扩展内容）
      if (currentGameDifficulty && !gameConfigResource[prefix]) {
        const targetCategory = findCatgeory(
          {
            sub_category: categoryList,
          },
          (cat) =>
            cat &&
            cat.prefix &&
            cat.prefix === prefix &&
            cat.resource_type === gameConfigCategoryResourceType,
        )
        if (targetCategory && currentGameDifficulty) {
          const temp = generateGameConfigResource({
            category_id: targetCategory.id,
            name: prefix,
            prefix: prefix,
            data: _.cloneDeep(currentGameDifficulty.data[prefix]),
          })
          delete currentGameDifficulty.data[prefix]
          gameConfigResource[prefix] = [temp]
        } else {
          throw new Error('没有找到对应的分类')
        }
      }
    })
  }

  if (!_.isEmpty(gameConfigKeysInsideGameConfigTab)) {
    _.each(gameConfigKeysInsideGameConfigTab, (prefix) => {
      // 没有从 gameConfigResource 找到对应的（说明是从玩法移动到了元素或扩展内容）
      if (currentGameDifficulty && !currentGameDifficulty.data[prefix]) {
        const targetCategory = findCatgeory(
          {
            sub_category: categoryList,
          },
          (cat) =>
            cat &&
            cat.prefix &&
            cat.prefix === prefix &&
            cat.resource_type === gameConfigCategoryResourceType,
        )
        if (targetCategory && currentGameDifficulty) {
          console.log(gameConfigResource[prefix])
          currentGameDifficulty.data[prefix] = _.get(
            gameConfigResource,
            `[${prefix}][0].data`,
          )
          delete gameConfigResource[prefix]
        } else {
          throw new Error('没有找到对应的分类')
        }
      }
    })
  }

  console.log(gameConfigResource)
  return gameConfigResource
}
